module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-top",
    class: {
      'visible': _vm.visible
    },
    attrs: {
      "data-scroll-offset": "0"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_vm._v(_vm._s(_vm.$t('go_up')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2ff5514"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrollTop.vue
// module id = 314
// module chunks = 0